module.exports = __webpack_public_path__ + "media/bootstrap-icons/gear-c1275a76.svg";